import { defaultCreateFormFieldSettings } from '@core/utils/dynamic-form-field/dynamic-form-field-helpers';
import { EntryTicketsFieldSettings } from '@features/account/features/tickets-and-orders/data-access/models/entry-tickets-api.model';
import { FieldSettings } from '@store/customization/customization.interfaces';
import { SelectOption } from '@store/exhibition/exhibition.interface';

export const userProfileFormDynamicFormFieldParametersMapper = (
  fieldSettings: FieldSettings,
  isSIAEEnabled: boolean,
  isGoogleMapsApiEnabled: boolean,
  isTelephoneValidationDisabled: boolean,
  isCountryFieldVisible: boolean,
  titles: SelectOption[],
  professions: SelectOption[],
  departments: SelectOption[],
  occupationalGroups: SelectOption[]
) => ({
  Salutation: {
    label: 'edit-user-profile-form.input.salutation.label',
    placeholder: 'edit-user-profile-form.input.salutation.placeholder'
  },
  PersonTitle: {
    label: 'edit-user-profile-form.input.title.label',
    placeholder: 'edit-user-profile-form.input.title.placeholder',
    titles
  },
  FirstName: {
    label: 'edit-user-profile-form.input.first-name.label',
    placeholder: 'edit-user-profile-form.input.first-name.placeholder'
  },
  LastName: {
    label: 'edit-user-profile-form.input.last-name.label',
    placeholder: 'edit-user-profile-form.input.last-name.placeholder'
  },
  Company: {
    label: 'edit-user-profile-form.input.company.label',
    placeholder: 'edit-user-profile-form.input.company.placeholder',
    isGoogleMapsApiEnabled
  },
  PersonFunction: {
    label: 'edit-user-profile-form.input.position.label',
    placeholder: 'edit-user-profile-form.input.position.placeholder',
    positions: professions
  },
  Department: {
    label: 'edit-user-profile-form.input.department.label',
    placeholder: 'edit-user-profile-form.input.department.placeholder',
    departments
  },
  OccupationalGroup: {
    label: 'edit-user-profile-form.input.occupational-group.label',
    placeholder: 'edit-user-profile-form.input.occupational-group.placeholder',
    occupationalGroups
  },
  Country: {
    label: 'edit-user-profile-form.input.country.label',
    placeholder: 'edit-user-profile-form.input.country.placeholder'
  },
  Street: {
    label: 'edit-user-profile-form.input.street.label',
    placeholder: 'edit-user-profile-form.input.street.placeholder'
  },
  ZipCode: {
    label: 'edit-user-profile-form.input.zip-code.label',
    placeholder: 'edit-user-profile-form.input.zip-code.placeholder',
    isCountryFieldVisible
  },
  City: {
    label: 'edit-user-profile-form.input.city.label',
    placeholder: 'edit-user-profile-form.input.city.placeholder'
  },
  Phone: {
    label: 'edit-user-profile-form.input.phone.label',
    placeholder: 'edit-user-profile-form.input.phone.placeholder',
    isTelephoneValidationDisabled,
    createFormFieldSettings: {
      ...defaultCreateFormFieldSettings,
      isDisabled: fieldSettings.Phone.isReadOnly || isSIAEEnabled
    }
  },
  Email: {
    label: 'edit-user-profile-form.input.email.label',
    placeholder: 'edit-user-profile-form.input.email.placeholder'
  },
  MailConfirm: {
    label: 'edit-user-profile-form.input.email-verify.label',
    placeholder: 'edit-user-profile-form.input.email-verify.placeholder'
  },
  SearchAddress: {
    label: 'edit-user-profile-form.input.address.label',
    placeholder: 'edit-user-profile-form.input.address.placeholder',
    isGoogleMapsApiEnabled
  },
  VatNumber: {
    label: 'edit-user-profile-form.input.vat.label',
    placeholder: 'edit-user-profile-form.input.vat.placeholder'
  },
  DateOfBirth: {
    label: 'edit-user-profile-form.input.date-of-birth.label',
    placeholder: 'edit-user-profile-form.input.date-of-birth.placeholder'
  }
});

export const buyerInformationFormDynamicFormFieldParametersMapper = (
  isReadOnly: boolean,
  isGoogleMapsApiEnabled: boolean,
  isTelephoneValidationDisabled: boolean,
  isCountryFieldVisible: boolean,
  titles: SelectOption[],
  professions: SelectOption[],
  departments: SelectOption[],
  occupationalGroups: SelectOption[]
) => ({
  Salutation: {
    label: 'buyer-information.buyer-information-form.input.salutation.label',
    placeholder: 'buyer-information.buyer-information-form.input.salutation.placeholder'
  },
  PersonTitle: {
    label: 'buyer-information.buyer-information-form.input.title.label',
    placeholder: 'buyer-information.buyer-information-form.input.title.placeholder',
    titles
  },
  FirstName: {
    label: 'buyer-information.buyer-information-form.input.first-name.label',
    placeholder: 'buyer-information.buyer-information-form.input.first-name.placeholder'
  },
  LastName: {
    label: 'buyer-information.buyer-information-form.input.last-name.label',
    placeholder: 'buyer-information.buyer-information-form.input.last-name.placeholder'
  },
  Company: {
    label: 'buyer-information.buyer-information-form.input.company.label',
    placeholder: 'buyer-information.buyer-information-form.input.company.placeholder',
    isGoogleMapsApiEnabled
  },
  PersonFunction: {
    label: 'buyer-information.buyer-information-form.input.position.label',
    placeholder: 'buyer-information.buyer-information-form.input.position.placeholder',
    positions: professions
  },
  Department: {
    label: 'buyer-information.buyer-information-form.input.department.label',
    placeholder: 'buyer-information.buyer-information-form.input.department.placeholder',
    departments
  },
  OccupationalGroup: {
    label: 'buyer-information.buyer-information-form.input.occupational-group.label',
    placeholder: 'buyer-information.buyer-information-form.input.occupational-group.placeholder',
    occupationalGroups
  },
  Country: {
    label: 'buyer-information.buyer-information-form.input.country.label',
    placeholder: 'buyer-information.buyer-information-form.input.country.placeholder'
  },
  Street: {
    label: 'buyer-information.buyer-information-form.input.street.label',
    placeholder: 'buyer-information.buyer-information-form.input.street.placeholder'
  },
  ZipCode: {
    label: 'buyer-information.buyer-information-form.input.zip-code.label',
    placeholder: 'buyer-information.buyer-information-form.input.zip-code.placeholder',
    isReadOnly,
    isCountryFieldVisible
  },
  City: {
    label: 'buyer-information.buyer-information-form.input.city.label',
    placeholder: 'buyer-information.buyer-information-form.input.city.placeholder'
  },
  Phone: {
    label: 'buyer-information.buyer-information-form.input.phone.label',
    placeholder: 'buyer-information.buyer-information-form.input.phone.placeholder',
    isTelephoneValidationDisabled
  },
  Email: {
    label: 'buyer-information.buyer-information-form.input.email.label',
    placeholder: 'buyer-information.buyer-information-form.input.email.placeholder'
  },
  MailConfirm: {
    label: 'buyer-information.buyer-information-form.input.email-verify.label',
    placeholder: 'buyer-information.buyer-information-form.input.email-verify.placeholder'
  },
  SearchAddress: {
    label: 'buyer-information.buyer-information-form.input.address.label',
    placeholder: 'buyer-information.buyer-information-form.input.address.placeholder',
    isReadOnly,
    isGoogleMapsApiEnabled
  },
  VatNumber: {
    label: 'buyer-information.buyer-information-form.input.vat.label',
    placeholder: 'buyer-information.buyer-information-form.input.vat.placeholder'
  },
  DateOfBirth: {
    label: 'buyer-information.buyer-information-form.input.date-of-birth.label',
    placeholder: 'buyer-information.buyer-information-form.input.date-of-birth.placeholder'
  }
});

export const buyerBillingAddressFormDynamicFormFieldParametersMapper = (
  isGoogleMapsApiEnabled: boolean,
  isUserLoggedIn: boolean
) => ({
  Company: {
    label: 'buyer-information.buyer-billing-address-form.input.company.label',
    placeholder: 'buyer-information.buyer-billing-address-form.input.company.placeholder',
    isGoogleMapsApiEnabled,
    createFormFieldSettings: {
      ...defaultCreateFormFieldSettings,
      maxLengthValidation: 50,
      columns: {
        xs: 12,
        sm: 12,
        md: 12,
        lg: 12,
        xl: 12
      }
    }
  },
  Country: {
    label: 'buyer-information.buyer-billing-address-form.input.country.label',
    placeholder: 'buyer-information.buyer-billing-address-form.input.country.placeholder'
  },
  Address: {
    label: 'buyer-information.buyer-billing-address-form.input.address.label',
    placeholder: 'buyer-information.buyer-billing-address-form.input.address.placeholder',
    isGoogleMapsApiEnabled
  },
  Street: {
    label: 'buyer-information.buyer-billing-address-form.input.street.label',
    placeholder: 'buyer-information.buyer-billing-address-form.input.street.placeholder'
  },
  ZipCode: {
    label: 'buyer-information.buyer-billing-address-form.input.zip-code.label',
    placeholder: 'buyer-information.buyer-billing-address-form.input.zip-code.placeholder',
    isCountryFieldVisible: true
  },
  City: {
    label: 'buyer-information.buyer-billing-address-form.input.city.label',
    placeholder: 'buyer-information.buyer-billing-address-form.input.city.placeholder'
  },
  SaveAddress: {
    label: '',
    checkboxOptionLabel: 'buyer-information.billing-address-form.checkbox.save-address',
    isUserLoggedIn
  }
});

export const ticketHolderFormDynamicFormFieldParametersMapper = (
  fieldSettings: FieldSettings,
  isReadOnly: boolean,
  isGoogleMapsApiEnabled: boolean,
  isTelephoneValidationDisabled: boolean,
  isEmailAndConfirmEmailMandatory: boolean,
  isTicketRetrievalLinkTicketSendingOption: boolean,
  isCountryFieldVisible: boolean,
  titles: SelectOption[],
  professions: SelectOption[],
  departments: SelectOption[],
  occupationalGroups: SelectOption[]
) => ({
  Salutation: {
    label: 'ticket-assignment.ticket-holder-form.input.salutation.label',
    placeholder: 'ticket-assignment.ticket-holder-form.input.salutation.placeholder'
  },
  PersonTitle: {
    label: 'ticket-assignment.ticket-holder-form.input.title.label',
    placeholder: 'ticket-assignment.ticket-holder-form.input.title.placeholder',
    titles
  },
  FirstName: {
    label: 'ticket-assignment.ticket-holder-form.input.first-name.label',
    placeholder: 'ticket-assignment.ticket-holder-form.input.first-name.placeholder',
    createFormFieldSettings: {
      ...defaultCreateFormFieldSettings,
      isRequired: fieldSettings.FirstName.isMandatory || isTicketRetrievalLinkTicketSendingOption,
      maxLengthValidation: 50
    }
  },
  LastName: {
    label: 'ticket-assignment.ticket-holder-form.input.last-name.label',
    placeholder: 'ticket-assignment.ticket-holder-form.input.last-name.placeholder',
    createFormFieldSettings: {
      ...defaultCreateFormFieldSettings,
      isRequired: fieldSettings.LastName.isMandatory || isTicketRetrievalLinkTicketSendingOption,
      maxLengthValidation: 50
    }
  },
  Company: {
    label: 'ticket-assignment.ticket-holder-form.input.company.label',
    placeholder: 'ticket-assignment.ticket-holder-form.input.company.placeholder',
    isGoogleMapsApiEnabled
  },
  PersonFunction: {
    label: 'ticket-assignment.ticket-holder-form.input.position.label',
    placeholder: 'ticket-assignment.ticket-holder-form.input.position.placeholder',
    positions: professions
  },
  Department: {
    label: 'ticket-assignment.ticket-holder-form.input.department.label',
    placeholder: 'ticket-assignment.ticket-holder-form.input.department.placeholder',
    departments
  },
  OccupationalGroup: {
    label: 'ticket-assignment.ticket-holder-form.input.occupational-group.label',
    placeholder: 'ticket-assignment.ticket-holder-form.input.occupational-group.placeholder',
    occupationalGroups
  },
  Country: {
    label: 'ticket-assignment.ticket-holder-form.input.country.label',
    placeholder: 'ticket-assignment.ticket-holder-form.input.country.placeholder'
  },
  Street: {
    label: 'ticket-assignment.ticket-holder-form.input.street.label',
    placeholder: 'ticket-assignment.ticket-holder-form.input.street.placeholder'
  },
  ZipCode: {
    label: 'ticket-assignment.ticket-holder-form.input.zip-code.label',
    placeholder: 'ticket-assignment.ticket-holder-form.input.zip-code.placeholder',
    isReadOnly,
    isCountryFieldVisible
  },
  City: {
    label: 'ticket-assignment.ticket-holder-form.input.city.label',
    placeholder: 'ticket-assignment.ticket-holder-form.input.city.placeholder'
  },
  Phone: {
    label: 'ticket-assignment.ticket-holder-form.input.phone.label',
    placeholder: 'ticket-assignment.ticket-holder-form.input.phone.placeholder',
    isTelephoneValidationDisabled
  },
  Email: {
    label: 'ticket-assignment.ticket-holder-form.input.email.label',
    placeholder: 'ticket-assignment.ticket-holder-form.input.email.placeholder',
    isEmailAndConfirmEmailMandatory
  },
  MailConfirm: {
    label: 'ticket-assignment.ticket-holder-form.input.email-verify.label',
    placeholder: 'ticket-assignment.ticket-holder-form.input.email-verify.placeholder',
    isEmailAndConfirmEmailMandatory
  },
  SearchAddress: {
    label: 'ticket-assignment.ticket-holder-form.input.address.label',
    placeholder: 'ticket-assignment.ticket-holder-form.input.address.placeholder',
    isReadOnly,
    isGoogleMapsApiEnabled
  },
  DateOfBirth: {
    label: 'ticket-assignment.ticket-holder-form.input.date-of-birth.label',
    placeholder: 'ticket-assignment.ticket-holder-form.input.date-of-birth.placeholder'
  }
});

export const ticketHolderEmailAndVerifyEmailFormFieldParametersMapper = (isEmailAndConfirmEmailMandatory: boolean) => ({
  Email: {
    label: 'ticket-assignment.ticket-holder-form.input.email.label',
    placeholder: 'ticket-assignment.ticket-holder-form.input.email.placeholder',
    isEmailAndConfirmEmailMandatory
  },
  MailConfirm: {
    label: 'ticket-assignment.ticket-holder-form.input.email-verify.label',
    placeholder: 'ticket-assignment.ticket-holder-form.input.email-verify.placeholder',
    isEmailAndConfirmEmailMandatory
  }
});

export const savedTicketHolderFormDynamicFormFieldParametersMapper = (
  fieldSettings: FieldSettings,
  isGoogleMapsApiEnabled: boolean,
  isTelephoneValidationDisabled: boolean,
  titles: SelectOption[],
  professions: SelectOption[],
  departments: SelectOption[],
  occupationalGroups: SelectOption[]
) => ({
  Salutation: {
    label: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.salutation.label',
    placeholder: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.salutation.placeholder'
  },
  PersonTitle: {
    label: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.title.label',
    placeholder: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.title.placeholder',
    titles
  },
  FirstName: {
    label: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.first-name.label',
    placeholder: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.first-name.placeholder'
  },
  LastName: {
    label: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.last-name.label',
    placeholder: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.last-name.placeholder'
  },
  Company: {
    label: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.company.label',
    placeholder: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.company.placeholder',
    isGoogleMapsApiEnabled
  },
  PersonFunction: {
    label: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.position.label',
    placeholder: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.position.placeholder',
    positions: professions
  },
  Department: {
    label: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.department.label',
    placeholder: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.department.placeholder',
    departments
  },
  OccupationalGroup: {
    label: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.occupational-group.label',
    placeholder: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.occupational-group.placeholder',
    occupationalGroups
  },
  Country: {
    label: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.country.label',
    placeholder: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.country.placeholder'
  },
  Street: {
    label: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.street.label',
    placeholder: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.street.placeholder'
  },
  ZipCode: {
    label: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.zip-code.label',
    placeholder: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.zip-code.placeholder',
    isCountryFieldVisible: fieldSettings.Country.isVisible
  },
  City: {
    label: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.city.label',
    placeholder: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.city.placeholder'
  },
  Phone: {
    label: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.phone.label',
    placeholder: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.phone.placeholder',
    isTelephoneValidationDisabled
  },
  Email: {
    label: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.email.label',
    placeholder: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.email.placeholder'
  },
  MailConfirm: {
    label: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.email-verify.label',
    placeholder: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.email-verify.placeholder'
  },
  SearchAddress: {
    label: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.address.label',
    placeholder: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.address.placeholder',
    isGoogleMapsApiEnabled
  },
  DateOfBirth: {
    label: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.date-of-birth.label',
    placeholder: 'profile.saved-ticket-holders.saved-ticket-holder-form.input.date-of-birth.placeholder'
  }
});

export const ticketsAndOrdersEditTicketHolderFormDynamicFormFieldParametersMapper = (
  fieldSettings: EntryTicketsFieldSettings,
  isGoogleMapsApiEnabled: boolean,
  isTelephoneValidationDisabled: boolean,
  titles: SelectOption[],
  professions: SelectOption[],
  departments: SelectOption[],
  occupationalGroups: SelectOption[]
) => ({
  Salutation: {
    label: 'account.tickets-and-orders.edit-ticket-holder-form.input.salutation.label',
    placeholder: 'account.tickets-and-orders.edit-ticket-holder-form.input.salutation.placeholder'
  },
  PersonTitle: {
    label: 'account.tickets-and-orders.edit-ticket-holder-form.input.title.label',
    placeholder: 'account.tickets-and-orders.edit-ticket-holder-form.input.title.placeholder',
    titles
  },
  FirstName: {
    label: 'account.tickets-and-orders.edit-ticket-holder-form.input.first-name.label',
    placeholder: 'account.tickets-and-orders.edit-ticket-holder-form.input.first-name.placeholder'
  },
  LastName: {
    label: 'account.tickets-and-orders.edit-ticket-holder-form.input.last-name.label',
    placeholder: 'account.tickets-and-orders.edit-ticket-holder-form.input.last-name.placeholder'
  },
  Company: {
    label: 'account.tickets-and-orders.edit-ticket-holder-form.input.company.label',
    placeholder: 'account.tickets-and-orders.edit-ticket-holder-form.input.company.placeholder',
    isGoogleMapsApiEnabled
  },
  PersonFunction: {
    label: 'account.tickets-and-orders.edit-ticket-holder-form.input.position.label',
    placeholder: 'account.tickets-and-orders.edit-ticket-holder-form.input.position.placeholder',
    positions: professions
  },
  Department: {
    label: 'account.tickets-and-orders.edit-ticket-holder-form.input.department.label',
    placeholder: 'account.tickets-and-orders.edit-ticket-holder-form.input.department.placeholder',
    departments
  },
  OccupationalGroup: {
    label: 'account.tickets-and-orders.edit-ticket-holder-form.input.occupational-group.label',
    placeholder: 'account.tickets-and-orders.edit-ticket-holder-form.input.occupational-group.placeholder',
    occupationalGroups
  },
  Country: {
    label: 'account.tickets-and-orders.edit-ticket-holder-form.input.country.label',
    placeholder: 'account.tickets-and-orders.edit-ticket-holder-form.input.country.placeholder'
  },
  Street: {
    label: 'account.tickets-and-orders.edit-ticket-holder-form.input.street.label',
    placeholder: 'account.tickets-and-orders.edit-ticket-holder-form.input.street.placeholder'
  },
  ZipCode: {
    label: 'account.tickets-and-orders.edit-ticket-holder-form.input.zip-code.label',
    placeholder: 'account.tickets-and-orders.edit-ticket-holder-form.input.zip-code.placeholder',
    isCountryFieldVisible: fieldSettings.Country.isVisible
  },
  City: {
    label: 'account.tickets-and-orders.edit-ticket-holder-form.input.city.label',
    placeholder: 'account.tickets-and-orders.edit-ticket-holder-form.input.city.placeholder'
  },
  Phone: {
    label: 'account.tickets-and-orders.edit-ticket-holder-form.input.phone.label',
    placeholder: 'account.tickets-and-orders.edit-ticket-holder-form.input.phone.placeholder',
    isTelephoneValidationDisabled
  },
  Email: {
    label: 'account.tickets-and-orders.edit-ticket-holder-form.input.email.label',
    placeholder: 'account.tickets-and-orders.edit-ticket-holder-form.input.email.placeholder',
    createFormFieldSettings: {
      ...defaultCreateFormFieldSettings,
      isRequired: true,
      isHidden: false,
      maxLengthValidation: 100,
      emailValidation: true,
      emailCaseInsensitiveValidation: true
    }
  },
  SearchAddress: {
    label: 'account.tickets-and-orders.edit-ticket-holder-form.input.address.label',
    placeholder: 'account.tickets-and-orders.edit-ticket-holder-form.input.address.placeholder',
    isGoogleMapsApiEnabled
  },
  DateOfBirth: {
    label: 'account.tickets-and-orders.edit-ticket-holder-form.input.date-of-birth.label',
    placeholder: 'account.tickets-and-orders.edit-ticket-holder-form.input.date-of-birth.placeholder'
  }
});
